export default {"src":"/_next/static/media/fb-review-icon.12c6a343.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};